import axios, { AxiosResponse } from 'axios';
import { setupInterceptorsTo } from './Interceptors';
import { Application } from '@/models/ApplicationsModels';
import { Unternehmen } from '@/models/UnternehmenModels';
import { EditUserRequest, ResetUserPasswordRequest, UserRealmIdRequest, MergeUserRequest, ImportUserRequest } from '@/models/BenutzerModels';

/* DEV */
import config from '../../appsettings.dev.json';

/* PROD */
// const appsettings = await fetch('/appsettings.json');
// const config = await appsettings.json();

const env = window.__ENV__ ?? null;

const BASE_URL = (env != undefined && env?.BASE_URL != undefined && env?.BASE_URL != '' ? env?.BASE_URL : config.api.baseUrl) + '/v1';

const apiClient = setupInterceptorsTo(
  axios.create({
    baseURL: BASE_URL,
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
);

export default {
  //#region Application
  getAllApplications(): Promise<AxiosResponse> {
    return apiClient.get('/applications');
  },

  createApplication(data: Application): Promise<AxiosResponse> {
    return apiClient.post('/application', data);
  },

  updateApplication(data: Application): Promise<AxiosResponse> {
    return apiClient.put(`/application`, data);
  },

  deleteApplication(id: number): Promise<AxiosResponse> {
    return apiClient.delete(`/application/${id}`);
  },
  //#endregion

  //#region Database
  isDatabaseUpToDate(): Promise<AxiosResponse> {
    return apiClient.get('/database/status');
  },

  updateDatabase(): Promise<AxiosResponse> {
    return apiClient.get('/database/update');
  },
  //#endregion

  //#region Benutzer
  getKeycloakRealmUserById(data: UserRealmIdRequest): Promise<AxiosResponse> {
    return apiClient.get(`/benutzer/${data.id}/keycloak/${data.realm}`);
  },

  getAllKeycloakRealmUsers(realm: string): Promise<AxiosResponse> {
    return apiClient.get(`/benutzer/keycloak/${realm}`);
  },

  createKeycloakRealmUser(data: EditUserRequest): Promise<AxiosResponse> {
    return apiClient.post(`/benutzer/keycloak/${data.realm}`, data.user);
  },

  updateKeycloakRealmUser(data: EditUserRequest): Promise<AxiosResponse> {
    return apiClient.put(`/benutzer/keycloak/${data.realm}`, data.user);
  },

  resetKeycloakRealmUserPassword(data: ResetUserPasswordRequest): Promise<AxiosResponse> {
    return apiClient.put(`/benutzer/${data.id}/keycloak/${data.realm}/password`, data.data);
  },

  deleteKeycloakRealmUser(data: UserRealmIdRequest): Promise<AxiosResponse> {
    return apiClient.delete(`/benutzer/${data.id}/keycloak/${data.realm}`);
  },
  //#endregion

  //#region Archiv
  getAllUnternehmenArchivUsers(id: number): Promise<AxiosResponse> {
    return apiClient.get(`/benutzer/archiv/${id}`);
  },

  mergeArchivUser(data: MergeUserRequest): Promise<AxiosResponse> {
    return apiClient.put(`/benutzer/archiv/merge/${data.unternehmenId}`, data.user);
  },

  importArchivUser(data: ImportUserRequest): Promise<AxiosResponse> {
    return apiClient.put(`/benutzer/archiv/import/${data.unternehmenId}/user/${data.archivUserId}`, data.user);
  },
  //#endregion

  //#region Unternehmen
  getAllUnternehmen(): Promise<AxiosResponse> {
    return apiClient.get('/unternehmen');
  },

  unternehmenHasRealm(realm: string): Promise<AxiosResponse> {
    return apiClient.get(`/unternehmen/hasrealm/${realm}`);
  },

  createUnternehmen(data: Unternehmen): Promise<AxiosResponse> {
    return apiClient.post('/unternehmen', data);
  },

  createUnternehmenRealm(id: number): Promise<AxiosResponse> {
    return apiClient.post(`/unternehmen/${id}/realm`);
  },

  updateUnternehmen(data: Unternehmen): Promise<AxiosResponse> {
    return apiClient.put(`/unternehmen`, data);
  },

  deleteUnternehmen(id: number): Promise<AxiosResponse> {
    return apiClient.delete(`/unternehmen/${id}`);
  },
  //#endregion
};
